import React, {Component} from "react";
import SimpleDataTable from "../../../../modules/SimpleDataTable";
import {defaultTableChange} from "../../../../modules/custom/customTable";
import {getTableConfigReport} from "../configs/config";
import {fetchReportSO} from "../service";
import {contructQueryParam} from "../../../../Services/Utils";

class ReportSODetail extends Component {
    constructor(props) {
        super(props);
        this.state = {
            tableColumn: [],
            pagination:{
                limit: 5,
                page: 1,
                totalData: 0
            }
        }
    }

    componentDidMount = async () => {
        this.setState({
            tableColumn: getTableConfigReport(
                this.props.tab,
                this.props.controls.stockOpnameType?.value.value || null
            )
        });
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.controls.stockOpnameType !== this.props.controls.stockOpnameType) {
            this.setState({
                tableColumn: getTableConfigReport(
                    this.props.tab,
                    this.props.controls.stockOpnameType?.value.value || null
                )
            });
        }
    }

    handleChangePage = (tableState) => {
        this.setState((prevValue) => ({
            ...prevValue,
            pagination:{
                ...prevValue.pagination,
                page: tableState.page + 1,
            }
        }));
    };

    handleRowsPerPage = (tableState) => {
        this.setState((prevValue) => ({
            ...prevValue,
            pagination:{
                ...prevValue.pagination,
                page: 1,
                limit: tableState.rowsPerPage,
            }
        }));
    };

    render() {
        return (
            <>
                <SimpleDataTable
                    key={`${this.props.dataTable?.length}-${this.state.pagination.page}`}
                    data={this.props.dataTable}
                    columns={this.state.tableColumn}
                    toCount={this.props.dataTable?.length}
                    rowsPerPage={this.state.pagination.limit}
                    page={this.state.pagination.page - 1}
                    options={{...defaultTableChange(this.handleChangePage, this.handleRowsPerPage), serverSide: false}}
                />
            </>
        )
    }
}

export default ReportSODetail;